import { Injectable } from "@angular/core";
import { IEidosIcon } from "../config/environment.interface";
import { EidosIconType } from "../models/core-constant.model";

@Injectable({
    providedIn: 'root'
})
export class EidosUtilityIconsService {

    trashIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-trash',
        iconSize: 1.5,
    }
    deleteStrokeIcon: IEidosIcon = {
        iconType: EidosIconType.SVG,
        iconCode: 'delete-stroke',
        iconSize: 1,
    };
    deleteFillIcon: IEidosIcon = {
        iconType: EidosIconType.SVG,
        iconCode: 'delete-fill',
        iconSize: 0.9,
    };
    editIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-edit',
        iconSize: 1.5,
    }
    receiptIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-receipt',
        iconSize: 1.5,
    }
    plusIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-plus',
        iconSize: 1.5,
    }
    minusIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-minus',
        iconSize: 1.5,
    }
    exclamationIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-exclamation',
        iconSize: 1.5,
    }
    exclamationTriangleIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-exclamation-triangle',
        iconSize: 1.5,
    }
    eyeIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-eye',
        iconSize: 1.5,
    }
    finalizeIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-clipboard-check',
        iconSize: 1.5,
    }
    invoiceIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-money-bill',
        iconSize: 1.5,
    }
    pdfIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-file-pdf',
        iconSize: 1.5,
    }
    downloadIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-download',
        iconSize: 1.5,
    }
    checkedIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-check-square',
        iconSize: 1.5,
    }
    uncheckedEmptyIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'far fa-square',
        iconSize: 1.5,
    }
    uncheckedIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-square',
        iconSize: 1.5,
    }
    doubleCheckedIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-check-double',
        iconSize: 1.5,
    }
    geoPathIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-globe-americas',
        iconSize: 1.5,
    };
    arrowUpIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-arrow-up',
        iconSize: 1.5,
    };
    arrowDownIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-arrow-down',
        iconSize: 1.5,
    };
    arrowRightIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-arrow-right',
        iconSize: 1.5,
    };
    arrowLeftIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-arrow-left',
        iconSize: 1.5,
    };
    copyIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-copy',
        iconSize: 1.5,
    };
    searchIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-search',
        iconSize: 1.5,
    };
    externalLinkIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-external-link-alt',
        iconSize: 1.5,
    };
    linkIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-link',
        iconSize: 1.5,
    };
    historyIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-history',
        iconSize: 1.5,
    };
    undoIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-undo',
        iconSize: 1.5,
    };
    confirmIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-check',
        iconSize: 1.5,
    };
    carIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-car',
        iconSize: 1.5,
    };
    carStrokeIcon: IEidosIcon = {
        iconType: EidosIconType.SVG,
        iconCode: 'car-stroke',
        iconSize: 1,
    };
    moneyIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-dollar-sign',
        iconSize: 1.5,
    };
    timesIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-times',
        iconSize: 1.5,
    };
    eraseIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-eraser',
        iconSize: 1.5,
    };
    houseUserIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-house-user',
        iconSize: 1.5,
    }
    planeSlashIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-plane-slash',
        iconSize: 1.5,
    }
    planeIcon: IEidosIcon = {
        iconType: EidosIconType.SVG,
        iconCode: 'plane-stroke',
        iconSize: 1,
    };
    shieldHalvedIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-shield-halved',
        iconSize: 1.5,
    };
    userIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-user',
        iconSize: 1.5,
    };
    userShieldIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-user-shield',
        iconSize: 1.5,
    };
    calendarXMarkIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-calendar-xmark',
        iconSize: 1.5,
    };
    calendarIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-calendar-alt',
        iconSize: 1.5,
    };
    guestIcon: IEidosIcon = {
        iconType: EidosIconType.SVG,
        iconCode: 'guest-stroke',
        iconSize: 2,
    };
    taskIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: "fa-tasks",
        iconSize: 1.5,
    };
    syncIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fas fa-repeat',
        iconSize: 1.5,
    }
    angleCloseIcon = {
        iconType: EidosIconType.SVG,
        iconCode: 'angle-close',
        iconSize: 2,
    }
    angleOpenIcon = {
        iconType: EidosIconType.SVG,
        iconCode: 'angle-close',
        iconSize: 2,
    }
    compassIcon: IEidosIcon = {
        iconType: EidosIconType.SVG,
        iconCode: 'compass-stroke',
        iconSize: 1,
    };
    routeStrokeIcon: IEidosIcon = {
        iconType: EidosIconType.SVG,
        iconCode: 'route-stroke',
        iconSize: 1,
    };
    tableIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-table',
        iconSize: 1.5,
    };
    toAirRequestIcon: IEidosIcon = {
        iconType: EidosIconType.SVG,
        iconCode: 'to-air-request',
        iconSize: 1,
    };
    cruiseIcon: IEidosIcon = {
        iconType: EidosIconType.SVG,
        iconCode: 'cruise',
        iconSize: 1,
    };
    fileIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-file',
        iconSize: 1.5,
    };
    fileAltIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-file-alt',
        iconSize: 1.5,
    };
    fileExportIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-file-export',
        iconSize: 1.5,
    };
    clockIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-clock',
        iconSize: 1.5,
    };
    fontIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-font',
        iconSize: 1.5,
    };
    calendarPlusIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-calendar-plus',
        iconSize: 1.5,
    };
    locationArrowIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-location-arrow',
        iconSize: 1.5,
    };
    userTieIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-user-tie',
        iconSize: 1.5,
    };
    hotelIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-hotel',
        iconSize: 1.5,
    };
    imagesIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-images',
        iconSize: 1.5,
    };
    closeIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa fa-xmark',
        iconSize: 1.5,
    };

    childIcon: IEidosIcon = {
        iconType: EidosIconType.Awesome,
        iconCode: 'fa-child',
        iconSize: 1.5,
    };
    mapPinIcon: IEidosIcon = {
      iconType: EidosIconType.Awesome,
      iconCode: 'fa-map-pin',
      iconSize: 1.5,
  };
}
